import React, { useState } from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import CustomTable from '../../../../../components/CustomTable';
import { customTableColumns } from './CustomTableColumns';

import SurveyResponseDetailModal from '../SurveyResponseDetailModal';


const ResultTables = ({surveyType = 'Encuesta'}) => {
   const { surveyResults,
           isLoading,
           error,
           surveyType: reduxSurveyType } = useSelector(state => state.surveyResults);
   
   const finalSurveyType = reduxSurveyType || surveyType;
   
   const safeData = Array.isArray(surveyResults) ? surveyResults : [];
   
   // Estados para el modal de detalles
   const [showDetailModal, setShowDetailModal] = useState(false);
   const [selectedSurveyUserId, setSelectedSurveyUserId] = useState(null);

   // Estados para el modal de detalles - agregado surveyId
   const [selectedSurveyId, setSelectedSurveyId] = useState(null);

   const handleViewDetails = (surveyUserId, surveyId) => {
     if (surveyUserId && surveyId) {
       setSelectedSurveyUserId(surveyUserId);
       setSelectedSurveyId(surveyId);
       setShowDetailModal(true);
     }
   };

   const handleCloseModal = () => {
     setShowDetailModal(false);
     setSelectedSurveyUserId(null);
     setSelectedSurveyId(null);
   };

   const columns = customTableColumns(finalSurveyType, handleViewDetails);
   
  return (
    <Container className="mt-3">
      {
        error && <Alert variant="danger">{error}</Alert>
      }
      <CustomTable 
        columns={columns}
        data={safeData}
        isLoadingData={isLoading}
        isErrorToLoadData={!!error}
        maySortableRows={false} />
      
      {/* Modal para mostrar detalles de respuestas */}
      <SurveyResponseDetailModal
        show={showDetailModal}
        onHide={handleCloseModal}
        surveyUserId={selectedSurveyUserId}
        surveyId={selectedSurveyId}
      />
    </Container>
  )
}

export default ResultTables